import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';
import { HttpService } from './http.service';
import { Equipment } from '../model/equipment';
import { FindHttpError } from '../error/find-http-error';

@Injectable()
export class EquipmentService {
  private static EQUIPMENT_END_POINT = '/equipment';

  private FIND_BY_IMEI = `${EquipmentService.EQUIPMENT_END_POINT}/findByImeiContains`;
  private FIND_BY_SERIAL = `${EquipmentService.EQUIPMENT_END_POINT}/findBySerialContains`;
  private FIND_BY_SERIAL_AND_STATUS = `${EquipmentService.EQUIPMENT_END_POINT}/findByStatusAndSerialContains`;

  find$: Observable<any>;
  error$: Observable<any>;

  private findSubject: Subject<any>;
  private errorSubject: Subject<any>;

  constructor(private _httpService: HttpService) {
    this.findSubject = new Subject();
    this.find$ = this.findSubject.asObservable();
    this.errorSubject = new Subject();
    this.error$ = this.errorSubject.asObservable();
  }

  findByImei(imei) {
    this.findEquipment(this._httpService.get(`${this.FIND_BY_IMEI}/${imei}`, Array, FindHttpError));
  }

  findBySerial(serial) {
    this.findEquipment(this._httpService.get(`${this.FIND_BY_SERIAL}/${serial}`, Array, FindHttpError));
  }

  findBySerialAndStatus(serial, status) {

    const finalUrl = `${this.FIND_BY_SERIAL_AND_STATUS}/${serial}?status=${status}`;

    this.findEquipment(this._httpService.get(finalUrl, Array, FindHttpError));
  }

  private findEquipment(observable) {
    observable
      .subscribe(
        equipment => this.findSubject.next(equipment),
        error => this.errorSubject.next(error)
      );
  }

}



// WEBPACK FOOTER //
// /home/jenkins/workspace/production-argos-front/argos/src/app/shared/service/equipment.service.ts